import { render, staticRenderFns } from "./PushDetail.vue?vue&type=template&id=4678daa2&scoped=true"
import script from "./PushDetail.vue?vue&type=script&lang=js"
export * from "./PushDetail.vue?vue&type=script&lang=js"
import style0 from "./PushDetail.vue?vue&type=style&index=0&id=4678daa2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4678daa2",
  null
  
)

export default component.exports